// controllers/salesPaymentController.js  (frontend)
// NOTE: Ye gateway wala paymentController.js NAHI hai (Razorpay/Cashfree/Paytm/PhonePe).
// Ye sirf offline/manual collected payments (cash, cheque, UPI wagera) ko sales invoices
// ke against record karne ke liye hai — isliye naam alag rakha hai taaki conflict na ho.
import apiService from '../services/apiService';
import { authController } from './authController';

const _getUser = () => authController.getCurrentUser();
const _getRole = () => _getUser()?.role || null;

const _guard = (allowedRoles) => {
  const role = _getRole();
  if (!role)                        return { blocked: true, reason: 'Not authenticated. Please log in.' };
  if (!allowedRoles.includes(role)) return { blocked: true, reason: `Access denied. Requires: ${allowedRoles.join(' or ')}` };
  return { blocked: false };
};

const ALLOWED = ['admin', 'super_admin', 'sales_manager', 'sales_rep'];

const salesPaymentController = {
  getCurrentUser: () => _getUser(),
  getCurrentRole: () => _getRole(),
  isSuperAdmin:   () => _getRole() === 'super_admin',
  isAdmin:        () => ['admin', 'super_admin'].includes(_getRole()),

  getAllPayments: async (filters = {}) => {
    const g = _guard(ALLOWED);
    if (g.blocked) return { success: false, data: [], message: g.reason };
    try {
      const qs  = new URLSearchParams(filters).toString();
      const res = await apiService.get(qs ? `sales-payments?${qs}` : 'sales-payments');
      return { success: true, data: res.data || [], pagination: res.pagination || {} };
    } catch (e) { return { success: false, data: [], message: e.message || 'Failed to fetch payments' }; }
  },

  getPaymentById: async (id) => {
    const g = _guard(ALLOWED);
    if (g.blocked) return { success: false, data: null, message: g.reason };
    try {
      const res = await apiService.get(`sales-payments/${id}`);
      return { success: true, data: res.data };
    } catch (e) { return { success: false, data: null, message: e.message || 'Payment not found' }; }
  },

  createPayment: async (data) => {
    const g = _guard(ALLOWED);
    if (g.blocked) return { success: false, message: g.reason };
    try {
      const res = await apiService.post('sales-payments', data);
      return { success: true, data: res.data, message: 'Payment recorded successfully' };
    } catch (e) { return { success: false, message: e.message || 'Failed to record payment' }; }
  },

  updatePayment: async (id, updates) => {
    const g = _guard(ALLOWED);
    if (g.blocked) return { success: false, message: g.reason };
    try {
      const res = await apiService.put(`sales-payments/${id}`, updates);
      return { success: true, data: res.data, message: 'Payment updated successfully' };
    } catch (e) { return { success: false, message: e.message || 'Failed to update payment' }; }
  },

  updateStatus: async (id, status) => {
    const g = _guard(ALLOWED);
    if (g.blocked) return { success: false, message: g.reason };
    try {
      const res = await apiService.patch(`sales-payments/${id}/status`, { status });
      return { success: true, data: res.data, message: 'Status updated successfully' };
    } catch (e) { return { success: false, message: e.message || 'Failed to update status' }; }
  },

  deletePayment: async (id) => {
    const g = _guard(['super_admin', 'admin']);
    if (g.blocked) return { success: false, message: g.reason };
    try {
      await apiService.delete(`sales-payments/${id}`);
      return { success: true, message: 'Payment deleted successfully' };
    } catch (e) { return { success: false, message: e.message || 'Failed to delete payment' }; }
  },

  getStatistics: async (filters = {}) => {
    const g = _guard(ALLOWED);
    if (g.blocked) return { success: false, data: null, message: g.reason };
    try {
      const qs  = new URLSearchParams(filters).toString();
      const res = await apiService.get(qs ? `sales-payments/statistics?${qs}` : 'sales-payments/statistics');
      return { success: true, data: res.data };
    } catch (e) { return { success: false, data: null, message: e.message }; }
  },
};

export default salesPaymentController;